import styled from 'styled-components';

const CloseButton = styled.button.attrs(() => ({ type: 'button' }))<{ $top?: number }>`
    position: absolute;
    top: ${props => `${props.$top}px`};
    right: 2px;
    border-color: transparent;
    background-color: transparent;
    display: flex;
    width: 19px;
    height: 19px;
    justify-content: center;
    padding: 0;

    cursor: pointer;
`;

export default CloseButton;
